import { useEffect, useState } from 'react';

export const useInitialiseEmbed = (Hash) => {
  const [simulationData, setSimulationData] = useState(null);

  useEffect(() => {
    const handleSimData = (event) => {
      const {
        Hash: EventHash,
        event: eventName,
        simulationData: data,
      } = event.data;

      if (EventHash !== Hash) {
        return;
      }
      if (eventName === 'initialise') {
        setSimulationData(data);
      }
    };
    window.addEventListener('message', handleSimData, false);
    window.parent.postMessage({
      event: 'ready',
      Hash,
    });

    return () => {
      window.removeEventListener('message', handleSimData, false);
    };
  }, [Hash]);

  return { simulationData };
};

export default useInitialiseEmbed;
